const e = {
  rejectButtonVariant: "decision"
};
export {
  e as default
};
